import { render, staticRenderFns } from "./decimal.vue?vue&type=template&id=153ec566"
import script from "./decimal.vue?vue&type=script&lang=js"
export * from "./decimal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports